import React from "react";
import Image from "components/image";
import { SocialMedia, GroupLinks as GroupLinksMobile } from "components/link-types";
import { PrivacyLinks } from "../desktop/data";
import PaymentIcons from "components/payment-icons";
import Link from "helpers/link";
import { isMobile } from "react-device-detect";
import TotalReviews from "components/total-reviews";
import { useSelector } from "react-redux";

export const FooterSocial = ({ data }) => (
	<div className="flex flex-col p-5">
		<div className="w-full">
			<Image width={64} image={data?.logo} />
		</div>
		<p className="text-sm">{data?.tagline}</p>
		<div className="w-full flex flex-row justify-between max-w-[60%] mt-6">
			{data?.showSocialIcons && <SocialMedia list={["instagram", "facebook", "youtube", "linkedin", "tiktok"]} />}
		</div>
	</div>
);

export const GroupLinks = ({ links }) => (
	<div className="flex flex-col">
		{links?.map((group) => (
			<GroupLinksMobile key={group._key} data={group} />
		))}
	</div>
);

export const FooterIcons = ({ icons, privacyLinks }) => {
	const { isClient } = useSelector((state) => state.global);

	return (
		<div className="flex flex-col gap-4 justify-center my-10">
			<PaymentIcons data={icons?.paymentIcons} />
			<div className="flex flex-row justify-center mobile-menu-border-top py-8">
				<Link to={icons?.reviews?.url}>
					<div className="w-40">
						<TotalReviews direction="vertical" />
					</div>
				</Link>
				<div className="w-40">
					<Image image={icons?.carbonNeutral} alt={icons?.carbonNeutral?.alt} />
				</div>
			</div>
			{isMobile && isClient && <PrivacyLinks data={privacyLinks} />}
		</div>
	);
};
